// @TODO: <HEALTH2019>
(function () {
    App.directive('healthFormRebate', healthFormRebateDirective);
    healthFormRebateDirective.$inject = ['Config'];

    function healthFormRebateDirective(Config) {
        return {
            restrict: 'E',
            scope: {
                onFormSubmit: '&',
                listPersons: '<',
                listFormsOfContact: '<',
                busy: '<'
            },
            templateUrl: Config.TEMPLATES_DIR + 'Components/health-form-rebate.html',
            controller: HealthFormRebateController,
            controllerAs: '$ctrl',
            bindToController: true,
        }
    }

    HealthFormRebateController.$inject = ['popUpService'];

    function HealthFormRebateController(popUpService) {
        var self = this;

        self.model = {
            type: 'REFUND_70',
            person: '',
            bankAccountNumber: '',
            serviceDescription: '',
            serviceDate: '',
            servicePrice: '',
            serviceFiles: [],
            agreements: {},
        };
        self.formRebate = null;

        self.maxDate = new Date();
        self.minDate = moment().add(-3, 'year').toDate();

        self.fileSelected = function (file) {
            if (self.model.serviceFiles.length >= 3) {
                popUpService.showPopUp({
                    head: 'Wystąpił błąd',
                    content: 'Maksymalnie można wybrać 3 pliki'
                });
                return;
            }
            self.model.serviceFiles.push(file[0]);
        };

        self.fileError = function (error) {
            switch (error) {
                case 'FILE_IS_TOO_BIG':
                    popUpService.showPopUp({
                        head: 'Wystąpił błąd',
                        content: 'Wybrany plik jest zbyt duży. Maksymalny rozmiar pliku: 5MB'
                    });
                    break;
                case 'FILE_WRONG_FORMAT':
                    popUpService.showPopUp({
                        head: 'Wystąpił błąd',
                        content: 'Wybrano plik niewłaściwego formatu. Dostępne rozszerzenia pliku: pdf, jpg, png'
                    });
                    break;
                default:
                    popUpService.showPopUp({
                        head: 'Wystąpił błąd',
                        content: 'Wystąpił problem z wybranym plikiem'
                    });
            }
        };

        self.formSubmitted = function (form) {
            if (!self.model.agreements.agreementsFirst
                || !self.model.agreements.agreementsSecond
                || !self.model.agreements.agreementsThird
                || !self.model.agreements.agreementsFourth) {
                popUpService.showPopUp({
                    head: 'Wystąpił błąd',
                    content: 'Aby wysłać formularz należy zaznaczyć wszystkie wymagane zgody'
                });
                return;
            }
            if (form.$invalid) {
                popUpService.showPopUp({
                    head: 'Wystąpił błąd',
                    content: 'Aby wysłać formularz należy wypełnić prawidłowo wszystkie pola'
                });
                return;
            }
            if (self.model.serviceFiles.length < 1) {
                popUpService.showPopUp({
                    head: 'Wystąpił błąd',
                    content: 'Aby wysłać formularz należy dodać przynajmniej jeden plik'
                });
                return;
            }

            self.onFormSubmit && self.onFormSubmit({$event: self.model});
        };

        self.deleteFile = function (index) {
            self.model.serviceFiles.splice(index, 1);
        };

        self.$onChanges = function (changes) {
            if (changes.listPersons && self.listPersons && self.listPersons.length) self.model.person = self.listPersons[0];
        };
    }
})();
// @TODO: </HEALTH2019>
